import { useState, useEffect } from 'react';
import DirectorDealsContent from "src/MarketDataComponents/DirectorDeals";
import { formatNumber } from "src/MarketDataComponents/Helpers";
import moment from 'moment';

const TIMEFRAME_3M = 3;
const TIMEFRAME_6M = 6;
const TIMEFRAME_1Y = 12;

export default function DirectorDealsSection({directorDeals}) {
    const [filteredDirectorDeals, setFilteredDirectorDeals] = useState([]);
    const [timeFrame, setTimeFrame] = useState(TIMEFRAME_3M);

    useEffect(() => {
        const todaysDate = new Date();
		todaysDate.setMonth(todaysDate.getMonth() - timeFrame);

		const filteredDirectorDeals = [];

		directorDeals.forEach((item, key) => {
            let itemCopy = {...item};
			let dateParsed = new Date(item.filingDate);
			if (dateParsed.getTime() > todaysDate.getTime() ) {
                itemCopy.filingDate = moment(dateParsed).format('DD/MM/YYYY');
                itemCopy.transactionAmount = formatNumber(item.transactionAmount, 0);
				filteredDirectorDeals.push(itemCopy);
			}
		});

        setFilteredDirectorDeals(filteredDirectorDeals);
    }, [timeFrame]);

    return <div className="ajb-grid-row margin-top-20">
        <div className="ajb-col-collapse">
            <div className="ajb-col-12 ajb-col-8-breakpoint">
                <div className="card z-depth-0 margin-0">
                    <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">

                        {filteredDirectorDeals ? <div className="ajb-grid-row">

                            <div className="ajb-grid-row">
                                <div className="ajb-col-collapse">
                                    <div className="ajb-col-6 ajb-col-8-breakpoint">
                                        <h2 className="card-title" data-testid="directorDealsHeader">Directors deals</h2>
                                    </div>
                                    <div className="ajb-col-6 ajb-col-8-breakpoint director-deals-tab-container">
                                        
                                        <div className="row">
                                            <div className="col s12">
                                                <ul className="tabs">
                                                    <li className="tab col">
                                                        <a 
                                                            data-testid="directorDeals3mTab"
                                                            className={timeFrame === TIMEFRAME_3M ? "active" : ""} 
                                                            href="" onClick={e => {
                                                                e.preventDefault();
                                                                setTimeFrame(TIMEFRAME_3M);
                                                            }}>3M</a>
                                                    </li>
                                                    <li className="tab col">
                                                        <a 
                                                            data-testid="directorDeals6mTab"
                                                            className={timeFrame === TIMEFRAME_6M ? "active" : ""} 
                                                            href="" onClick={e => {
                                                                e.preventDefault();
                                                                setTimeFrame(TIMEFRAME_6M);
                                                            }}>6M</a>
                                                    </li>
                                                    <li className="tab col">
                                                        <a 
                                                            data-testid="directorDeals1yTab"
                                                            className={timeFrame === TIMEFRAME_1Y ? "active" : ""} 
                                                            href="" onClick={e => {
                                                                e.preventDefault();
                                                                setTimeFrame(TIMEFRAME_1Y);
                                                            }}>1Y</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <hr className="ajb-grid-row margin-top-0" />
                            </div>

                            <DirectorDealsContent defaultTableClassName="data-table data-table--small data-table--scroll highlight margin-0" deals={filteredDirectorDeals} />

                        </div> : null}

                    </div>
                </div>
            </div>
        </div>
    </div>
}